import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { OptionsService } from '../services/options.service'
import { setResponseFactorsOptions } from '../store/options.actions'

export function* getResponseFactorsOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getResponseFactorsOptions])
    const { entity } = response
    if (entity) entity.push({ id: 20, name: 'Other', isPN: false, isNV: false, nemsisCode: 2209013 })
    yield put(setResponseFactorsOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getResponseFactorsOptions() error: ${e}`))
  }
}

export function* getResponseFactorsOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getResponseFactorsOptions)
}
